var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('bookman-navbar'),_c('router-view'),(_vm.isFooterShown)?_c('bookman-footer'):_vm._e(),_c('fullpage-loader'),_c('start-ebook-modal'),_c('continue-reading-ebook-modal'),_c('sign-in-up-modal')],1)}
var staticRenderFns = []

export { render, staticRenderFns }